import useOnRedactionSearchCompleted from './useOnRedactionSearchCompleted';

export default useOnRedactionSearchCompleted;